export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9176.591388e1.jpg";